import { useEffect, useMemo, useState } from "react";
import debounce from "lodash.debounce";

/** Debounces a rapidly-changing value (e.g. search text) — updates `delayMs` after `value` settles. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  const setDebouncedValue = useMemo(() => debounce((v: T) => setDebounced(v), delayMs), [delayMs]);

  useEffect(() => {
    setDebouncedValue(value);
  }, [value, setDebouncedValue]);

  useEffect(() => () => setDebouncedValue.cancel(), [setDebouncedValue]);

  return debounced;
}
